<template>
  <div class="donezo">
      Congratulations! You have finished all the pending revisions!
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.donezo {
  width: 100vw;
  height: 65vh;
  max-width: 100%;
  text-align: center;
  font-size: 15px;
  margin-top: 20px;
}
</style>